
import { Events, FileUploadWithPreview, } from 'file-upload-with-preview';

import { useEffect } from "react";

import importedBaseImage from './custom-image.svg';

export const UploadImageContainer = (props) => {
    // Allow callers to pass className/style to constrain the upload widget
    const className = ['custom-file-container', props.className || ''].join(' ').trim();
    return (
        <div className={className} data-upload-id="imageCollection" style={props.style}>
            {props.children}
        </div>
    );

}

export const UploadAndDisplayImage2 = ({addImage, maxFileCount, multiple, chooseFile, label}) => {

    // https://github.com/johndatserakis/file-upload-with-preview

    useEffect(() => {
        const handler = (e) => {
            const { detail } = e;
            if (typeof addImage === 'function') addImage(detail.cachedFileArray);
        };

        window.addEventListener(Events.IMAGE_ADDED, handler);
        return () => window.removeEventListener(Events.IMAGE_ADDED, handler);
    }, [addImage]);

    useEffect(() => {
        new FileUploadWithPreview('imageCollection', {
            images: {
                baseImage: importedBaseImage,
            },
            maxFileCount: maxFileCount ?? 1,
            multiple: multiple ?? false,
            text: {
                browse: '...',
                chooseFile: chooseFile ?? 'Choose your files...',
                label: label ?? 'Choose your files...',
            }
        });
    }, [maxFileCount, multiple, chooseFile, label]);
    return <></>
}



export const UploadAndDisplayImage = (props) => {

    // https://github.com/johndatserakis/file-upload-with-preview

    useEffect(() => {
        const handler = (e) => {
            const { detail } = e;
            if (props && typeof props.addImage === 'function') props.addImage(detail.cachedFileArray);
        };

        window.addEventListener(Events.IMAGE_ADDED, handler);
        return () => window.removeEventListener(Events.IMAGE_ADDED, handler);
    }, [props]);

    useEffect(() => {
        new FileUploadWithPreview('imageCollection', {
            images: {
                baseImage: importedBaseImage,
            },
            maxFileCount: 10,
            multiple: true,
            text: {
                browse: '...',
                chooseFile: 'Choose your files...',
                label: 'Choose your files...',
            }
        });
    }, []);
    return <></>
}